import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";
import PasswordField from "@/components/PasswordField";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) {
      setError(t.reset.min);
      return;
    }
    if (password !== confirm) {
      setError(t.reset.match);
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Error");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center bg-white p-6">
        <div className="max-w-md w-full text-center">
          <p className="font-mono text-sm text-[#4a4a4a]">{t.reset.invalid}</p>
          <Link
            to="/"
            className="mt-4 inline-block px-4 py-3 bg-[#0a0a0a] text-white font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#ff006e] transition-colors"
          >
            {t.reset.back}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-white p-6">
      <div className="w-full max-w-md border border-[#0a0a0a] shadow-[8px_8px_0_0_rgba(10,10,10,1)] p-8">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8a8a8a]">· kuryarti / reset</div>
        {done ? (
          <>
            <h2 className="mt-3 font-mono font-bold tracking-tighter text-2xl text-[#0a0a0a]">{t.reset.done_title}</h2>
            <p className="mt-2 font-sans text-sm text-[#4a4a4a]">{t.reset.done_sub}</p>
            <Link
              to="/"
              className="mt-6 block text-center px-4 py-3 bg-[#0a0a0a] text-white font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#ff006e] transition-colors"
            >
              {t.reset.back}
            </Link>
          </>
        ) : (
          <>
            <h2 className="mt-3 font-mono font-bold tracking-tighter text-2xl text-[#0a0a0a]">{t.reset.title}</h2>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <PasswordField
                tid="reset-password"
                label={t.reset.new_password}
                value={password}
                onChange={setPassword}
                autoComplete="new-password"
              />
              <PasswordField
                tid="reset-confirm"
                label={t.reset.confirm}
                value={confirm}
                onChange={setConfirm}
                autoComplete="new-password"
              />
              {error && <div className="font-mono text-xs text-[#ff006e]">{error}</div>}
              <button
                type="submit"
                disabled={loading}
                className="w-full px-4 py-3 bg-[#0a0a0a] text-white font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#ff006e] transition-colors disabled:opacity-50"
              >
                {loading ? t.auth.loading : t.reset.submit}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
